import React from 'react';

//Estilos base:
let oneLineText = { textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", marginBottom: 0, width: "100%" };

let CustomCheckbox = (props) => {
    return (
        <div className="form-check">
            <label className="form-check-label" style={{ ...oneLineText }}>
                <input type="checkbox" className="form-check-input"
                    checked={props.checked} onChange={(e) => { if (props.onChange !== undefined) { props.onChange(!props.checked); } }} />
                <span className="form-check-sign"></span>
                <span className="noselect">{props.itemRendering}</span>
            </label>
        </div>
    );
}

export default CustomCheckbox;